export const pubEventTypes = {
  PUB_EVENT_ONCHANGE: "PUB_EVENT_ONCHANGE",
  SELECTED_PUB_EVENT_CATEGORY: "SELECTED_PUB_EVENT_CATEGORY",
  SELECTED_PUB_EVENT_FILTER: "SELECTED_PUB_EVENT_FILTER",
  SELECTED_PUB_CLNDR_CATEGORY: "SELECTED_PUB_CLNDR_CATEGORY"
};
